import { useMemo } from 'react';
import { useLocalSearchParams } from 'expo-router';
import { JoinWorldCupGroupScreen } from '../../../../components/worldcup/JoinWorldCupGroupScreen/JoinWorldCupGroupScreen';

export default function WorldCupGroupJoinRoute() {
  const { code, autojoin } = useLocalSearchParams<{
    code?: string | string[];
    autojoin?: string | string[];
  }>();
  const initialCode = useMemo(() => {
    if (typeof code === 'string' && code.trim()) return code.trim();
    if (Array.isArray(code) && typeof code[0] === 'string' && code[0].trim()) return code[0].trim();
    return undefined;
  }, [code]);
  const autoJoin = useMemo(() => {
    const raw = Array.isArray(autojoin) ? autojoin[0] : autojoin;
    return raw === '1' || raw === 'true';
  }, [autojoin]);
  return <JoinWorldCupGroupScreen initialCode={initialCode} autoJoin={autoJoin} />;
}
